import React, { ReactElement } from 'react';
import ListItemTextInternal from '@mui/material/ListItemText';
import FormatService from '../../services/format-service';
import useStylesListItemText from './list-item-text.styles';

const ListItemText: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const COMPONENT_SPAN: ListItemComponent = 'span';

  const {
    isBlock,
    isBlockRight,
    isMultiline,
    isHeader,
    isInline,
    subText,
    className,
    children,
  } = props;

  const { classes } = useStylesListItemText();

  const blockClassName: string | undefined = isBlock ? classes.listItemTextBlock : undefined;
  const rightBlockClassName: string | undefined = isBlockRight ? classes.listItemTextBlockRight : undefined;
  const multilineClassName: string | undefined = isMultiline ? classes.listItemTextMultiline : undefined;
  const headerClassName: string | undefined = isHeader ? classes.listItemTextHeader : undefined;
  const inlineClassName: string | undefined = isInline ? classes.listItemTextInline : undefined;

  return (
    <ListItemTextInternal
      className={FormatService.formatClassNames(blockClassName, rightBlockClassName, multilineClassName, className)}
      primary={children || undefined}
      secondary={subText || undefined}
      classes={{
        primary: FormatService.formatClassNames(headerClassName, inlineClassName),
        secondary: inlineClassName,
      }}
      secondaryTypographyProps={{
        component: COMPONENT_SPAN,
      }}
    />
  );
});

export default ListItemText;
